import React, { useContext, useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { Card, Checkbox } from '../../../Components/Common';
import AdditionalCard from '../../../Components/Common/AdditionalPlanCards/AdditionalCard';
import ArrowIcon from '../../../Components/Common/Svg/ArrowIcon';
import TickGreen from '../../../Components/Common/Svg/TickGreen';
import InfoIcon from '../../../Components/Common/Svg/InfoIcon';
import QuestionMarkBlackBgS from '../../../Components/Common/Svg/QuestionMarkBlackS';

import { SalesContext } from '../../../Context/SalesContext';

import {
  tagOnAdditionalService,
  tagOnRemoveAdditionalService
} from "../../../Tagging/SalesTagging";
import ServiceItems from "./ServiceItems/ServiceItems";

import { isMobileView } from '../../../Utility/utility'

import './AdditionalServices.css';

const AdditionalServicesC = (props) => {

  const context = useContext(SalesContext);
  const [isReadMoreLte, setReadMoreLte] = useState(true);
  const [isReadMoreSuperWifi, setReadMoreSuperWifi] = useState(true);
  const [isShowOptionsSuperWifi, setShowOptionsSuperWifi] = useState(false);
  const [isShowOptionsContractCover, setShowOptionsContractCover] = useState(false);
  const [isShowOptionsLte, _setShowOptionsLte] = useState(false);

  const longTextLte = (
    <div className="longText">
      While waiting for the fibre installation, you&apos;ll enjoy FREE LTE for a whole month! After the first month, you can stay connected on your preferred LTE plan below. Once fibre is up and running, the LTE service will stop and you&apos;ll pay for the fibre line instead.
    </div>
  );
  const shortTextLte = (
    <div className="shortTextSuperWifi">
      While waiting for the fibre installation, you&apos;ll enjoy FREE LTE for a whole month! After the first month, you can stay...
    </div>
  );
  const linkNameLte = isReadMoreLte ? 'read more' : 'read less';

  const longTextSuperWifi = (
    <div className="longTextSuperWifi">
      Super WiFi provides fast, reliable WiFi coverage to every corner of your home, ensuring that you and your home are always connected.
      Our homes are now more connected than ever with internet-enabled devices becoming a greater part of our daily lives. In some homes, there may be WiFi blackspots which can result in limited coverage in certain parts of your home.
      <br />
      <br />
      Super WiFi uses small WiFi access points which work together with our Vodacom home broadband router, to create a smart and dynamic network. This network adjusts to create the best possible connection for your home and connected devices so everyone can enjoy a seamless online experience.
    </div>
  );
  const shortTextSuperWifi = (
    <div className="shortTextSuperWifi">
      Super WiFi provides fast, reliable WiFi coverage to every corner of your home, ensuring that you and your home are always connected.
    </div>
  );
  const linkNameSuperWifi = isReadMoreSuperWifi ? 'Learn more':'Show less';

  const {
    additionalServices,
    setAdditionalServices,
    setAdditionalVas,
    setSelectedAdditionalServices,
    selectedAdditionalServices,
    leadAdditionalServices,
    setLeadAdditionalServices
  } = context;

  function updateAdditionalServices(service, value) {
    if (service.vasCategory === "superWifi" && superWifiPackages.length > 0) {
      if(!isShowOptionsSuperWifi && context.selectedContractTerm)
        setShowOptionsSuperWifi(true);
      else
        setShowOptionsSuperWifi(false);

      return;
    }
    else if (service.vasCategory === "contractCover") {
      setShowOptionsContractCover(!isShowOptionsContractCover);

      return;
    }
    else {
      setSelectedAdditionalServices({ key: service.vasCategory, value: value });
      let currentServices = leadAdditionalServices;

      if (service.action === "lead") {
        if (value) {
          currentServices.push(service.vasCategory)
        } else {
          currentServices.splice(currentServices.indexOf(service.vasCategory), 1)
        }

        setLeadAdditionalServices(currentServices);
      }

      if (value) {
        additionalServiceTagger(service);
      }
      else {
        tagOnRemoveAdditionalService(service.acronym, 1, service.priceDescription)
      }
    }
  }

  const additionalServiceTagger = service => {
    let price = service.priceDescription;
    tagOnAdditionalService(service.acronym, 1, price);
  }

  const handleProductSelect = (service, product) => {
    // Handle product Select change
    let ObjIndex = additionalServices.findIndex(item => item.vasCategory === service.vasCategory);
    let productIndex = additionalServices[ObjIndex].products.findIndex(item => item.price === product.price);

    additionalServices[ObjIndex].products.map(item => item['selected'] = false);
    additionalServices[ObjIndex].products[productIndex]['selected'] = true;
    additionalServices[ObjIndex]['selectedProductSpeed'] = additionalServices[ObjIndex].products[productIndex].speed;
    additionalServices[ObjIndex]['selectedProductPrice'] = additionalServices[ObjIndex].products[productIndex].price;
    setAdditionalServices(additionalServices);

    props.updateTotalCost();
  }

  const onCheckboxClick = (e, vasCategory) => {
    let addVas = context.additionalVas;

    if (addVas) {
      for (let index = 0; index < addVas.length; index++) {
        if (addVas[index].category === vasCategory) {
          addVas.splice(index, 1);
        }
      }
    }

    setAdditionalVas(addVas);

    if (vasCategory == "contractCover")
      context.setUnselectedContractCover(true);

    setSelectedAdditionalServices({ key: vasCategory, value: false });
    // e.stopPropagation();
  }

  var superWifiPackages = [];
  var additionalServicesVAS = [];

  if (additionalServices && additionalServices.serviceCategories) {
    additionalServices.serviceCategories.map((service) => {
      if (service.vasCategory == "superWifi" && service.offerId) {
        if (!parseInt(service.contractTerm)
          || ( context.selectedContractTerm
              && service.contractTerm == context.selectedContractTerm.duration )
        )
          superWifiPackages.push(service);
      } else
        additionalServicesVAS.push(service);
    })
  }

  useEffect(() => {
    additionalServicesVAS.map((item) => {
      if (item.vasCategory == "contractCover"
        && !context.selectedAdditionalServices.contractCover
        && !context.unselectedContractCover
      ) {
        let addVas = context.additionalVas;
        let addContractCover = true

        if (!addVas)
          addVas = [];

        for (let index = 0; index < addVas.length; index++) {
          if (addVas[index].category === "contractCover")
            addContractCover = false;
        }

        if (addContractCover)
          addVas.push({
            "category" : item.vasCategory,
            "offerId" : item.offerId,
            "price" : "R" + item.priceDescription,
            "contractTerm" : item.contractTerm,
            "acronym" : item.acronym,
            "displayName" : item.displayName,
            "priceDescription": item.priceDescription,
            "discount": item.discount ? item.discount : "",
            "imgUrl": item.imageUrl
          });

        setSelectedAdditionalServices({ key: item.vasCategory, value: true });
        tagOnAdditionalService(
          item.acronym,
          1,
          item.priceDescription
        );
        setAdditionalVas(addVas)
      }
    })
  }, [additionalServices])

  if (superWifiPackages.length > 0)
    additionalServicesVAS.unshift({
      "vasCategory": "superWifi",
      "offerId": null,
      "name": null,
      "price": null,
      "contractTerm": null,
      "services": null,
      "displayName": "Super WiFi",
      "imageUrl": "https://contentqa.vodacom.co.za/content/fibre/sales/images/saleslead_superwifi_image.png",
      "promotion": null,
      "priceDescription": null,
      "description": "Boost the WiFi coverage throughout your home.",
      "acronym": "Super WiFi"
    })

  additionalServicesVAS.map((item, index) => {
    if (item.vasCategory == "contractCover" && index != 0) {
      additionalServicesVAS.unshift(item);
      additionalServicesVAS.splice(index + 1, 1)
    }
  })

  let selectedSuperWifi;
  let selectedContractCover;

  let addVas = context.additionalVas;

  if (addVas) {
    for (let index = 0; index < addVas.length; index++) {
      if (addVas[index].category == "superWifi") {
        selectedSuperWifi = addVas[index]
      }

      if (addVas[index].category == "contractCover") {
        selectedContractCover = addVas[index]
      }
    }
  }

  return (
    <div>
      { additionalServicesVAS.length > 0 &&
        <div>
          <p
            className='plan-details-additional-services title'
            automationid="SalesLead_Paragraph_AdditionalServicesTitle_0"
          >
            Interested in any of these additional services?
          </p>
        </div>
      }

      <div className='additional-services-container' automationid="SalesLead_Div_AdditionalServicesContainer_0">
        { additionalServicesVAS.length > 0
          && additionalServicesVAS.map((service, index) => {

            if (service?.vasCategory !== 'lte') {

              return (
                <React.Fragment key={index}>
                  { service.vasCategory == "contractCover"
                    ? <div className='plan-details-contract-cover-banner'>
                        <InfoIcon></InfoIcon>
                        <div className='plan-details-contract-cover-banner-text'>
                          We’ve added Contract Cover by default because we believe in its value for you. You can remove it, but before you do, please read why we think you should keep it...
                        </div>
                      </div>
                    : null
                  }
  
                  <Card
                    automationidattr={`AdditionalServices`}
                    automationIndex={index}
                    isLteToggle={props.isLteToggle}
                    currentToggleState={props.currentToggleState}
                    isActiveCard={props.isActiveCard}
                  >
                    <div
                      className='service-container'
                      automationid={`SalesLead_Div_ServiceContainer_${index}`}
                      onClick={() => updateAdditionalServices(service, !selectedAdditionalServices[service.vasCategory])}
                    >
                      <div className='service-container-action' automationid={`SalesLead_Div_AdditionalServiceCheckBoxContainer_${index}`}>
                        {
                          <Checkbox
                            checked={ context.selectedAdditionalServices[service.vasCategory] }
                            onChange = {(e)=> onCheckboxClick(e,service.vasCategory)}
                          />
                        }
                      </div>
  
                      <div className='service-container-service'>
                        <div
                          className='service-container-details'
                          automationid={`SalesLead_Div_AdditionalServiceDetails_${index}`}
                        >
                          <div className="service-title-wrapper">
                            <span
                              className='service-title'
                              automationid={`SalesLead_Div_AdditionalServiceTitle_${index}`}
                            >
                              {service.acronym}
                            </span>
                            { service.promotion &&
                              <span className="lte-promotion-new" automationid="SalesLead_Div_AdditionalServicePromotion_0">{service.promotion}</span>
                            }
                            { service.vasCategory === "superWifi" && superWifiPackages.length > 0 &&
                              <div className="tbyb-promotion-info">TRY BEFORE YOU BUY</div>
                            }
                          </div>
  
                          <p
                            className='service-description'
                            automationid={`SalesLead_Div_AdditionalServiceDescription_${index}`}
                          >
                            {service.description}
                          </p>
  
                          { service.priceDescription === null || service.vasCategory === "contractCover"
                            ? null
                            : <p className='service-price' automationid={`SalesLead_Div_AdditionalServicePrice_${index}`}>
                                <span>{service.priceDescription}</span>
                              </p>
                          }
                        </div>
                      </div>
                      { selectedSuperWifi && service.vasCategory === 'superWifi' && !isMobileView()
                        ? <p className='selected-price' automationid={`SalesLead_Div_AdditionalServicePrice_${index}`}>
                            <span>{selectedSuperWifi?.price} {parseInt(selectedSuperWifi?.contractTerm) ? "PM x " + selectedSuperWifi?.contractTerm : "Once-off"}</span>
                          </p>
                        : null
                      }
  
                      { service.vasCategory === 'contractCover' && context.selectedAdditionalServices.contractCover === true && !isMobileView()
                        ? <p className='selected-price' automationid={`SalesLead_Div_AdditionalServicePrice_${index}`}>
                            <span>R{service?.priceDescription} PM</span>
                          </p>
                        : null
                      }
  
                      <div className='service-container-action' automationid={`SalesLead_Div_AdditionalServiceCheckBoxContainer_${index}`}>
                        { service.vasCategory === "superWifi" && superWifiPackages.length > 0 && context.selectedContractTerm
                          ? <button
                              className='arrow-toggle-btn'
                              onClick={() => {setShowOptionsSuperWifi(!isShowOptionsSuperWifi);}}
                              automationid={`SalesLead_Button_AdditionalServiceLteToggleButton_${index}`}
                            >
                            <ArrowIcon
                              direction={isShowOptionsSuperWifi ? 'icon-chevron-up' : 'icon-chevron-down'}
                              automationidattr={`SortBy`}
                            />
                            </button>
                          : null
                        }
  
                        { service.vasCategory === "contractCover"
                          ? <button
                              className='arrow-toggle-btn'
                              onClick={() => {setShowOptionsContractCover(!isShowOptionsContractCover);}}
                              automationid={`SalesLead_Button_AdditionalServiceLteToggleButton_${index}`}
                            >
                            <ArrowIcon
                              direction={isShowOptionsContractCover ? 'icon-chevron-up' : 'icon-chevron-down'}
                              automationidattr={`SortBy`}
                            />
                            </button>
                          : null
                        }
                      </div>
                    </div>
                  </Card>
  
                  { 
                    isShowOptionsSuperWifi === true && service?.vasCategory === 'superWifi' && superWifiPackages.length > 0
                    ? <React.Fragment>
                      <div className='LTE_PlansWrapper'>
                        <div>
                          <p className="service-title">Select your Super WiFi
                          </p>
                        </div>
  
                        <div className='cards_wrapper'>
                          { superWifiPackages.map((service, index) =>
                              <AdditionalCard
                                vasCategory={service?.vasCategory}
                                acronym={service?.acronym}
                                displayName={service?.displayName}
                                offerId={service?.offerId}
                                contractTerm={service?.contractTerm.replace("Months", "").trim()}
                                price={"R" + service?.priceDescription}
                                priceDescription={service?.priceDescription}
                                index={index}
                                discount={service?.discount}
                                imgUrl={service?.imageUrl}
                                key={index}
                                isSelected={selectedSuperWifi && selectedSuperWifi.offerId == service?.offerId}
                              />
                            )
                          }
                        </div>
  
                      </div>
  
                      <div className='additional-info-wrapper'>
                        <div className="tbyb-promotion-info">Try before you buy</div>
                        <div className="tbyb-promotion-info-text">
                          Enjoy a <strong>FREE 14-day trial</strong> once your fibre is installed and activated. In the meantime, your router will be delivered but you&apos;ll only start paying for it when the trial period is over.
                        </div>
                      </div>  
  
                      <div className='additional-info-wrapper'>
                          <div className="additional-info-title">
                            <p className="service-title">
                              <span className="service-title-icon">
                                <QuestionMarkBlackBgS></QuestionMarkBlackBgS>
                              </span>
                              What is Super WiFi?
                            </p>
                          </div>
  
  
                          { isReadMoreSuperWifi
                            ? shortTextSuperWifi
                            : longTextSuperWifi
                          }
  
                          <p
                            automationid=""
                            className="service-description"
                            onClick={()=> {setReadMoreSuperWifi(!isReadMoreSuperWifi)}}>
                            <span
                              className="toggleLongText">{linkNameSuperWifi}
                            </span>
                          </p>
                        </div>                  
                      
                    </React.Fragment>
                    : null
                  }
  
                  { isShowOptionsContractCover === true && service?.vasCategory === 'contractCover'
                    ? <React.Fragment>
                        <div className='LTE_PlansWrapper'>
                          <div className='cards_wrapper'>
                            <AdditionalCard
                              vasCategory={service?.vasCategory}
                              acronym={service?.acronym}
                              displayName={service?.displayName}
                              offerId={service?.offerId}
                              contractTerm={service?.contractTerm.replace("Months", "").trim()}
                              price={"R" + service?.priceDescription}
                              priceDescription={service?.priceDescription}
                              index={1}
                              imgUrl={service?.imageUrl}
                              key={1}
                              additionalText={service.description}
                              isSelected={selectedContractCover && selectedContractCover.offerId == service?.offerId}
                            />
                          </div>
                        </div>
  
                        <div className='additional-info-wrapper'>
                          <div className="additional-info-title">
                            <p className="service-title">
                              <div className="service-title-icon"><QuestionMarkBlackBgS></QuestionMarkBlackBgS></div>Why should I get contract cover?
                            </p>
                            <div className="service-title-additional-text">
                              <div className="service-title-additional-text-item">
                                <div className="service-title-additional-text-icon">
                                  <TickGreen></TickGreen>
                                </div>
                                If something fatal should happen to you, it would pay off the remainder of this contract so that your loved ones won’t have to.
                              </div>
                              <br />
                              <div className="service-title-additional-text-item">
                                <div className="service-title-additional-text-icon">
                                  <TickGreen></TickGreen>
                                </div>
                                Your family would receive R5,000 to help cover your funeral costs.
                              </div>
                            </div>
                          </div>
                        </div>
  
                      </React.Fragment>
                    : null
                  }
  
                  {/* { isShowOptionsLte === true && service?.serviceKey === 'lte' && props.servicePlans
                    ? <div className='LTE_PlansWrapper'>
                        <p className="service-title"
                          automationid=''>Which LTE package would you like?
                        </p>
  
                        {!isMobileView() &&
  
                          <p className="service-description" automationid="">
                            While waiting for the fibre installation, you&apos;ll enjoy FREE LTE for a whole month! After the first month, you can stay connected on your preferred LTE plan below.
                            Once fibre is up and running, the LTE service will stop and you&apos;ll pay for the fibre line instead.
                          </p>
                        }
  
                        { isReadMoreLte && isMobileView()
                          ? shortTextLte
                          : longTextLte
                        }
  
                        { isMobileView() &&
                          <p
                            automationid=""
                            className="service-description"
                            onClick={()=> {setReadMoreLte(!isReadMoreLte)}}>
                            <span
                              className="toggleLongText">{linkNameLte}
                            </span>
                          </p>
                        }
  
                        <div className='cards_wrapper'>
                          { props?.servicePlans?.map((service, index) =>
  
                            <AdditionalCard
                              serviceKey="lte"
                              size={service?.size}
                              price={"R" + service?.priceDescription}
                              parameterId={service?.actions[0]?.parameters[0]?.parameterId}
                              parameterValue={service?.actions[0]?.parameters[0]?.parameterValue}
                              handleOnSelect={service}
                              offerId={props?.offerId}
                              actionId={service?.actions[0]?.actionId}
                              category={props?.vasCategory}
                              displayName={props?.displayName}
                              promotion={props?.promotion}
                              activeIndex={service?.actions[0]?.parameters[0]?.parameterId}
                              key={service?.actions[0]?.parameters[0]?.parameterId}
                              currentActiveState={props?.currentActiveState}
                              isActiveCard={props?.isActiveCard}
                              onClick={() => props.handleSelectedCard(service?.actions[0]?.parameters[0]?.parameterId)}
                              cardActive={service?.actions[0]?.parameters[0]?.parameterId}
                              index={index}
                              updateTotalCost={props?.updateTotalCost}
                              priceValue={service?.price?.value}
                              imageUrl={props?.lteImageUrl}
                              taggingPlanName={props?.taggingPlanName}
                            />
                            )
                          }
  
                        </div>
                      </div>
                    : null
                  } */}
  
                  { service.showProduct
                    ? <ServiceItems
                        service={service}
                        onProductSelect={(service, product) => handleProductSelect(service, product)}
                      ></ServiceItems>
                    : null
                  }
                </React.Fragment>
              );
            }
            
          })}
      </div>
    </div>
  );
}

AdditionalServicesC.propTypes = {
  className: PropTypes.string,
  isLteToggle: PropTypes.bool,
  serviceList: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    priceDescription: PropTypes.string.isRequired,
    promotion: PropTypes.string,
    serviceName: PropTypes.string.isRequired,
    serviceUrl: PropTypes.string
  })).isRequired,
  updateTotalCost: PropTypes.func,
  handleToggle: PropTypes.func,
  currentToggleState: PropTypes.bool,
  servicePlans: PropTypes.array,
  isActiveCard: PropTypes.bool,
  offerId: PropTypes.string,
  vasCategory: PropTypes.string,
  displayName: PropTypes.string,
  promotion: PropTypes.string,
  currentActiveState: PropTypes.bool,
  handleSelectedCard: PropTypes.func,
  lteImageUrl: PropTypes.string,
  priceDescription: PropTypes.string,
  voiceLineImageUrl: PropTypes.string,
  superWifiImageUrl: PropTypes.string,
  taggingPlanName: PropTypes.string
}

AdditionalServicesC.defaultProps = {
  serviceList: []
}

export const AdditionalServices = AdditionalServicesC;